import { OnSuccessCallback, useCustomMutation } from './index';

import { QueryError, QueryKeys } from '../queries';

import Config from '../../config';
import { METHODS } from '../constants';
import { Connection } from '../../administration/clientAdministrationPage/types';


export const useClearBalanceSheetManagementBalances = (
  onSuccess?: OnSuccessCallback<Response, string[]>
) =>
  useCustomMutation<Response, QueryError, string[]>({
    handleData: companyCodes => ({
      url: Config.endpoints.CLEAR_BSM_BALANCES_IN_ALL_PERIODS,
      method: METHODS.DELETE,
      body: companyCodes,
    }),
    invalidateKey: [],
    errorMessage: 'Clearing BSM Balances failed',
    successMessage: 'BSM Balances cleared successfully',
    onSuccess,
  });

export const useRollToNextPeriod = (
  onSuccess?: OnSuccessCallback<Response, void>
) =>
  useCustomMutation<Response, QueryError, void>({
    handleData: () => ({
      url: Config.endpoints.ROLL_TO_NEXT_PERIOD,
      method: METHODS.POST,
    }),
    invalidateKey: [],
    errorMessage: 'Roll to next period failed',
    successMessage: 'Roll to next period started - an email notice will be sent upon completion',
    onSuccess,
  });

export const useUnlockAllTaxEntries = (
  onSuccess?: OnSuccessCallback<Response, void>
) =>
  useCustomMutation<Response, QueryError, void>({
    handleData: () => ({
      url: Config.endpoints.UNLOCK_ALL_TAX_ENTRIES,
      method: METHODS.DELETE,
    }),
    invalidateKey: [],
    errorMessage: 'Unlocking tax entries failed',
    successMessage: 'All tax entries unlocked successfully',
    onSuccess,
  });

export const useAddConnection = (
  onSuccess?: OnSuccessCallback<Response, Connection>
) =>
  useCustomMutation<Response, QueryError, Connection>({
    handleData: connection => ({
      url: Config.endpoints.ADD_ADMIN_CONNECTION,
      method: METHODS.POST,
      body: connection,
    }),
    invalidateKey: [],
    resetKey: QueryKeys.clientAdministration.ConnectionsList,
    errorMessage: 'Adding connection failed',
    successMessage: 'Connection successfully added',
    onSuccess,
  });

export const useUpdateConnection = (
  onSuccess?: OnSuccessCallback<Response, Connection>
) =>
  useCustomMutation<Response, QueryError, Connection>({
    handleData: connection => ({
      url: Config.endpoints.UPDATE_ADMIN_CONNECTION,
      method: METHODS.PUT,
      body: connection,
    }),
    invalidateKey: [],
    resetKey: QueryKeys.clientAdministration.ConnectionsList,
    errorMessage: 'Updating connection failed',
    successMessage: 'Connection successfully updated',
    onSuccess,
  });


export const useRefreshLeCc = (
  onSuccess?: OnSuccessCallback<Response, Connection>
) =>
  useCustomMutation<Response, QueryError, Connection>({
    handleData: () => ({
      url: Config.endpoints.REFRESH_LE_CC,
      method: METHODS.POST,
    }),
    invalidateKey: [],
    errorMessage: 'Refreshing LE/CC failed.',
    successMessage: 'Refreshing LE/CC started. It may take a while - an email notice will be sent upon completion',
    onSuccess,
  });

export const useUpdateMaintenanceFlag = (
  onSuccess?: OnSuccessCallback<Response, { maintenanceFlag: string }>
) =>
  useCustomMutation<Response, QueryError, { maintenanceFlag: string }>({
    handleData: ({ maintenanceFlag }) => ({
      url: Config.endpoints.UPDATE_MAINTENANCE_FLAG,
      method: METHODS.POST,
      body: { maintenanceFlag },
    }),
    invalidateKey: [],
    resetKey: query => [QueryKeys.clientAdministration.MaintenanceFlag,
      QueryKeys.idleProcess.Values].includes(query.queryKey[0] as string),
    errorMessage: 'Updating maintenance mode failed.',
    successMessage: 'Maintenance mode successfully updated',
    onSuccess,
  });

export const useUpdateLockClientFlag = (
  onSuccess?: OnSuccessCallback<Response, { lockFlag: string }>
) =>
  useCustomMutation<Response, QueryError, { lockFlag: string }>({
    handleData: ({ lockFlag }) => ({
      url: Config.endpoints.UPDATE_CLIENT_LOCK_FLAG,
      method: METHODS.POST,
      body: { lockFlag },
    }),
    invalidateKey: [],
    resetKey: query => [QueryKeys.clientAdministration.MaintenanceFlag,
      QueryKeys.idleProcess.Values].includes(query.queryKey[0] as string),
    errorMessage: 'Updating lock flag failed.',
    successMessage: 'Lock flag successfully updated',
    onSuccess,
  });
